import ButtonComponent from '@components/shared/button/ButtonComponent';
import { theme } from '@theme';
import { FC } from 'react';
import styled from 'styled-components';
import { useCheckDevice } from '../../../hooks/UseCheckDevice';

type TryAgainProps = {
  retry: () => void;
  bodyComponent: JSX.Element;
};

const TryAgain: FC<TryAgainProps> = ({ retry, bodyComponent }) => {
  const { isMobileDevice, isLandScape } = useCheckDevice();

  return (
    <Wrapper data-testid='try-again-container'>
      <TryAgainSection data-testid='try-again-section'>
        <TryAgainContainer data-testid='try-again' isLandScape={isLandScape}>
          {bodyComponent}

          <TryAgainButtonWrapper data-testid='try-again-button'>
            <ButtonComponent
              color={theme.palette.deepBlueTwo}
              borderColor={theme.palette.deepBlueTwo}
              wrapperBackgroundColor={theme.palette.gray}
              backgroundColor={theme.palette.gray}
              width={100}
              text={'Try again'}
              fontWeight={theme.typography.fontWeights.bold}
              outerPadding={'0px'}
              innerPadding={'7px 16px'}
              borderRadius={4}
              onClick={retry}
              display={'inline-block'}
              containerWidth={isMobileDevice ? '100' : 'none'}
            />
          </TryAgainButtonWrapper>
        </TryAgainContainer>
      </TryAgainSection>
    </Wrapper>
  );
};

export default TryAgain;

const Wrapper = styled.section`
  width: 100%;
  height: 100%;
  background: #f0f0f0;
  text-align: center;

  .try-again-header {
    line-height: 30px;
    text-wrap: pretty;
  }
`;

const TryAgainButtonWrapper = styled.div`
  position: relative;
  text-align: center;
`;

type TryAgainContainerProps = {
  isLandScape: boolean;
};

const TryAgainContainer = styled.div<TryAgainContainerProps>`
  width: 100%;
  text-align: center;
  padding: ${(props) => (props.isLandScape ? '5%' : '15% 5%')};
  display: inline-block;
  max-height: calc(100vh - 207px);
`;

const TryAgainSection = styled.div`
  width: 80%;
  display: inline-block;
`;
